export default "__VITE_ASSET__DSm15CYR__"